export const redeemCoupon = (data) => ({
  method: 'POST',
  endpoint: `/coupons/redeem`,
  body: data,
  prefix: " ",
});
